// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-card {
    display: flex;
    gap: 16px;
    padding: 16px;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    background: #fff;
    align-items: flex-start;
}

/* Image container */
.blog-image:hover {
  transform: scale(1.25);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.35);
  z-index: 10;
  position: relative;
}

.blog-image-wrapper:hover .blog-image {
    transform: scale(1.8);
    position: relative;
    z-index: 10;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4);
    transition: transform 0.4s ease;
}





/* Responsive */
@media (max-width: 768px) {
    .blog-card {
        flex-direction: column;
    }

  .blog-image-wrapper {
      overflow: hidden;
  }
}


/*    responsive   web  */
@media (max-width: 768px) {

    /* Stack flex items vertically, reduce padding/margins, smaller fonts */
    .container {
        flex-direction: column;
        padding: 16px;
    }

    h1 {
        font-size: 1.5rem;
    }

    img {
        max-width: 100%;
        height: auto;
    }
}

@media (max-width: 480px) {

    /* Further reductions for phones */
    .nav-bar {
        font-size: 20px;
        padding: 4px 8px;
    }

    .intro-box {
        padding: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/Blog.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,0CAA0C;IAC1C,+BAA+B;AACnC;;;;;;AAMA,eAAe;AACf;IACI;QACI,sBAAsB;IAC1B;;EAEF;MACI,gBAAgB;EACpB;AACF;;;AAGA,yBAAyB;AACzB;;IAEI,uEAAuE;IACvE;QACI,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;AACJ;;AAEA;;IAEI,kCAAkC;IAClC;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".blog-card {\n    display: flex;\n    gap: 16px;\n    padding: 16px;\n    border-radius: 10px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n    background: #fff;\n    align-items: flex-start;\n}\n\n/* Image container */\n.blog-image:hover {\n  transform: scale(1.25);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.35);\n  z-index: 10;\n  position: relative;\n}\n\n.blog-image-wrapper:hover .blog-image {\n    transform: scale(1.8);\n    position: relative;\n    z-index: 10;\n    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4);\n    transition: transform 0.4s ease;\n}\n\n\n\n\n\n/* Responsive */\n@media (max-width: 768px) {\n    .blog-card {\n        flex-direction: column;\n    }\n\n  .blog-image-wrapper {\n      overflow: hidden;\n  }\n}\n\n\n/*    responsive   web  */\n@media (max-width: 768px) {\n\n    /* Stack flex items vertically, reduce padding/margins, smaller fonts */\n    .container {\n        flex-direction: column;\n        padding: 16px;\n    }\n\n    h1 {\n        font-size: 1.5rem;\n    }\n\n    img {\n        max-width: 100%;\n        height: auto;\n    }\n}\n\n@media (max-width: 480px) {\n\n    /* Further reductions for phones */\n    .nav-bar {\n        font-size: 20px;\n        padding: 4px 8px;\n    }\n\n    .intro-box {\n        padding: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
